import {AfterViewChecked, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {Router} from '@angular/router';
import {SearchControllerService} from "../../../api/services/search-controller.service";
import {ValidationService} from "../../../services/validation-service/validation.service";
import {QuotationService} from "../../../services/quotation-service/quotation.service";
import {FormControl, FormGroup} from "@angular/forms";
import {ActivationControllerService} from "../../../api/services/activation-controller.service";
import {GtmService} from "../../../services/gtm-service/gtm.service";
import {CoverDetailsResponse} from "../../../api/models/cover-details-response";
import {CoverDetailsViewComponentItem} from "../../../api/models/cover-details-view-component-item";
import {CoverDetailsSaveRequest} from "../../../api/models/cover-details-save-request";
import {LeadService} from "../../../services/lead-service/lead.service";
import {HttpClient} from "@angular/common/http";

declare let jQuery: any;
declare let jcf:any

@Component({
  selector: 'app-activation-cover-details',
  templateUrl: './activation-cover-details.component.html'
})
export class ActivationCoverDetailsComponent implements OnInit, AfterViewChecked {
  viewLoading = false;
  view: CoverDetailsResponse
  isVehicleNew: boolean;
  coverDetailsForm: FormGroup = new FormGroup({});
  showWarrantyDetailsForm = false;
  modalHeading = null;
  modalContent = [];
  modalFragment = null;
  showToolTip = false;
  fullyWrapped = false;
  partiallyWrapped = false;
  noWrap = false;
  showSpinner = false;
  isVehicleWrappedFieldShown = false;
  vehicleWrappedModalClosed = false;
  noScratchAndDent = false;
  noPreInspectModal = false;
  comprehensiveMotorSelection = null;
  saveButtonClicked = false;
  notEligible = false;
  @ViewChild('openModal') openModal: ElementRef;

  constructor(public router: Router,
              public validationService: ValidationService,
              public quotationService: QuotationService,
              private _searchController: SearchControllerService,
              private _activationController: ActivationControllerService,
              private _validationService: ValidationService,
              private _gtmService: GtmService,
              private _changeDetector: ChangeDetectorRef,
              private _leadService: LeadService,
              private _httpClient: HttpClient) {
  }

  ngOnInit(): void {
    this._loadView();
    this.quotationService.scrollToTop();
    this.isVehicleNew = this.quotationService.vehicleInfo.isVehicleNew;
  }

  ngAfterViewChecked(): void {
    this._changeDetector.detectChanges();
  }

  private _loadView(): void {
    this.viewLoading = true;
    this._activationController.activationV1CoverDetailsGetResponse().subscribe(response => {
      this.viewLoading = false;
      if (response) {
        this.view = response.body;
        this._createForm();
      }
    }, error => {
      this.quotationService.error = true;
    })
  }

  private _createForm(): void {
    this.view.views.forEach(panel => {
      if (!panel.showCondition) {
        if (panel.id !== 'UNKNOWN') {
          panel.views.forEach(field => {
            this.coverDetailsForm.addControl(field.id, new FormControl({value: field.value, disabled: field.disabled}, this._validationService.getFieldValidators(field)));
          })
        }
      }
    });
    this._reloadJCF();
  }

  private _reloadJCF(): void {
    jQuery(function () {
      // @ts-ignore
      jcf.replaceAll();
    });
  }

  showElementBasedOnShowCondition(element: CoverDetailsViewComponentItem): boolean {
    if (element.showCondition) {
      return this.coverDetailsForm.controls[element.showCondition.id].value === element.showCondition.optionId[0];
    }
    return true;
  }

  updateFormBasedOnInputChange(field: CoverDetailsViewComponentItem, option): void {
    if (field.id === 'COVER_DETAILS_COVER_TYPE') {
      if (option === '85') {
        this.view.views.find(panel => panel.id ==='WARRANTY_DETAILS').views.forEach(field => {
          if (!field.showCondition || this.showElementBasedOnShowCondition(field)) {
            this.coverDetailsForm.addControl(field.id, new FormControl({value: field.value, disabled: field.disabled}, this.validationService.getFieldValidators(field)))
          }
          this.showWarrantyDetailsForm = true;
        })
        this._reloadJCF();
      } else {
        this.view.views.find(panel => panel.id ==='WARRANTY_DETAILS').views.forEach(field => {
          this.coverDetailsForm.removeControl(field.id);
        })
        this.showWarrantyDetailsForm = false;
      }
    }

    if (field.id === 'SCRATCH_AND_DENT_COVER_SELECT') {
      if (option === 'true') {
        if (this.view.views.find(panel => panel.id === 'SCRATCH_AND_DENT').views.find(field => field.id === 'SCRATCH_AND_DENT_VEHICLE_WRAPPED')) {
          this.coverDetailsForm.addControl(field.id, new FormControl({value: field.value, disabled: field.disabled}, this.validationService.getFieldValidators(field)));
          this.showToolTip = true;
        }
        this._reloadJCF();
      } else {
        this.noScratchAndDent = true;
      }
    }

    if (field.id === 'SCRATCH_AND_DENT_VEHICLE_WRAPPED') {
      if (option === '1') {
        this.fullyWrapped = true;
        this.setModalContent(field);
        this.openModal.nativeElement.click();
      } else if (option === '2') {
        this.partiallyWrapped = true;
        this.isVehicleWrappedFieldShown = true;
        this.setModalContent(field);
        this.openModal.nativeElement.click();
      } else if (option === '3') {
        this.noWrap = true;
        this.isVehicleWrappedFieldShown = true;
        this.setModalContent(field);
      }
    }

    if (field.id === 'WARRANTY_DETAILS_COVER') {
      if (option === 'true') {
        const fieldToAdd = this.view.views.find(panel => panel.id ==='WARRANTY_DETAILS').views.find(field => field.id === 'WARRANTY_DETAILS_EXPIRY_DATE');
        const validators = this.validationService.getFieldValidators(fieldToAdd, this.showElementBasedOnShowCondition(fieldToAdd));
        this.coverDetailsForm.addControl(fieldToAdd.id, new FormControl({value: fieldToAdd.value, disabled: fieldToAdd.disabled}, validators));
        this.coverDetailsForm.updateValueAndValidity();
      } else {
        this.coverDetailsForm.removeControl('WARRANTY_DETAILS_EXPIRY_DATE');
      }
    }

    if (field.id === 'COVER_DETAILS_VITALITY_DRIVE' && option === 'true') {
      this._reloadJCF();
    } else if (field.id === 'COVER_DETAILS_VITALITY_DRIVE' && option === 'false') {
      if (this.view.crowdSearchRequired === true && this.view.trackerRequired === true) {
        this.coverDetailsForm.controls['THIRD_PARTY_TRACKING_DEVICE_SELECT'].patchValue('87', {onlySelf: true, emitEvent: true, emitModelToViewChange: true, emitViewToModelChange: true});
      } else if (this.view.crowdSearchRequired === false && this.view.trackerRequired === true) {
        this.modalHeading = 'Security Device';
        this.modalFragment = 'You can get a security device that will increase our ability to recover your vehicle in the case of theft. Would you like to add the security device?';
        this.openModal.nativeElement.click();
        this.quotationService.scrollToTop();
      }
      this._reloadJCF();
    }
  }

  showFieldError(field): boolean {
    return this.coverDetailsForm.controls[field].invalid && this.coverDetailsForm.controls[field].dirty;
  }

  setModalContent(field: CoverDetailsViewComponentItem): void {
    if (!this.noWrap) {
      this.modalHeading = field.label;
    }

    this.modalContent = [];
    if (field.id === 'COVER_DETAILS_VITALITY_DRIVE') {
      const fragment = this.view.crowdSearchRequired ? '/vitality-drive-cs-indicator' : '/vitality-drive-no-cs-indicator';
      this._getContent(fragment).then(result => this.modalFragment = result);
    } else if (field.id === 'SVR_BENEFIT_OPTION_SELECT') {
      const fragment = this.coverDetailsForm.controls.SVR_BENEFIT_OPTION_SELECT.value === 'true' ? '/svr-benefit-yes' : '/svr-benefit-no';
      this._getContent(fragment).then(result => this.modalFragment = result);
    } else if (field.toolTip) {
      this.modalContent.push(field.toolTip);
    } else if (field.options[0].toolTip) {
      field.options.forEach(option => {
        this.modalContent.push({optionHeading: option.label, optionTooltip: option.toolTip})
      });
    }
    if (field.id === 'SCRATCH_AND_DENT_VEHICLE_WRAPPED') {
      if (this.showToolTip && !this.noWrap && !this.fullyWrapped && !this.partiallyWrapped) {
        this.modalHeading = 'Wrapping';
        this.modalContent.push('If the vehicle has an adhesive vinyl film, paint protection film or colour wrapping.');
      }
      if (this.fullyWrapped) {
        this.modalFragment = 'No scratch and dent cover can be provided for a vehicle that is fully wrapped.';
      } else if (this.partiallyWrapped) {
        this.modalFragment = 'Areas where the vehicle is wrapped will not be covered at claim stage';
      }
    }
    if (!this.noWrap) {
     this.quotationService.scrollToTop();
    }
  }

  private _getContent(fragment): any {
    return this._httpClient.get('/wcm/discoverycoza/fragments/insure/insure-online-activation' + fragment, {
      responseType: 'text'
    }).toPromise();
  }

  saveAndContinue(): void {
    this.showSpinner = true;
    this.saveButtonClicked = true;
    this.comprehensiveMotorSelection = this.coverDetailsForm.get(['COVER_DETAILS_COVER_TYPE']).value;
    if (this.isVehicleNew) {
      if (this.isVehicleNew.toString() === "false" && this.comprehensiveMotorSelection.toString() === "1") {
        this.modalHeading = 'Vehicle pre-inspection';
        this.modalFragment = 'Please complete the vehicle pre-inspection within five days of cover' +
          ' start date on the Discovery App to make sure that you are fully covered';
        if (this.noWrap || this.partiallyWrapped) {
          this.openModal.nativeElement.click();
        } else {
          this.noPreInspectModal = true;
        }
      } else {
        this.noPreInspectModal = true;
      }
    } else {
      this.noPreInspectModal = true;
    }
    this._activationController.activationV1CoverDetailsPutResponse(this._getCoverDetailsSaveRequest()).subscribe(response => {
      this.showSpinner = false;
      if (response.status === 200 && response.body.status === 'INVALID_STATE') {
        if (response.body.validations) {
          this.modalHeading = 'Not eligible';
          this.modalContent = [response.body.validations[0].message];
          this.notEligible = true;
          this.openModal.nativeElement.click();
          this.quotationService.scrollToTop();
        }
        this.quotationService.error = true;
      } else if (response.status === 200 && response.body.status === 'VALID') {
        this._leadService.insureRecommendedQuote = 'Cover details';
        this._leadService.updateLead().subscribe();
        this._gtmService.postGtmEvent('form_step_complete', 'submit_cover_details', 7);
        if (this.noPreInspectModal) {
          this.router.navigateByUrl('activation-banking-details');
        }
      } else {
        this.quotationService.error = true;
      }
    }, error => {
      this.quotationService.error =true;
    })
  }

  private _getCoverDetailsSaveRequest(): CoverDetailsSaveRequest {
    const answersMap = new Map();
    Object.keys(this.coverDetailsForm.controls).forEach(control => answersMap.set(control, this.coverDetailsForm.get(control).value));

    const coverDetailsSaveRequest: CoverDetailsSaveRequest = {
      activateVitalityDrive: answersMap.get('COVER_DETAILS_VITALITY_DRIVE'),
      coverCode: answersMap.get('COVER_DETAILS_COVER_TYPE'),
      coverStartDate: answersMap.get('COVER_DETAILS_COVER_START_DATE'),
      discoveryTrackingDevice: answersMap.get('SVR_BENEFIT_OPTION_SELECT'),
      thirdPartyTrackingDeviceCode: answersMap.get('THIRD_PARTY_TRACKING_DEVICE_SELECT'),
      scratchAndDentIndicator: answersMap.get('SCRATCH_AND_DENT_COVER_SELECT'),
      vehicleWrappedCode: this.isVehicleWrappedFieldShown ? answersMap.get('SCRATCH_AND_DENT_VEHICLE_WRAPPED') : 0
    }

    if (this.showWarrantyDetailsForm) {
      coverDetailsSaveRequest.warrantyDetails = {
        currentMileageCode: answersMap.get('WARRANTY_DETAILS_MILEAGE'),
        manufacturerExpiryDate: answersMap.get('WARRANTY_DETAILS_EXPIRY_DATE'),
        manufacturerWarranty: answersMap.get('WARRANTY_DETAILS_COVER'),
        rebuilt: answersMap.get('WARRANTY_DETAILS_REBUILT')
      };
    }

    return coverDetailsSaveRequest;
  }

  backToDefault () {
    if (this.fullyWrapped) {
      this.fullyWrapped = false;
      this.coverDetailsForm.controls['SCRATCH_AND_DENT_COVER_SELECT'].patchValue('false', {onlySelf: true, emitEvent: true, emitModelToViewChange: true, emitViewToModelChange: true});
      this.coverDetailsForm.controls['SCRATCH_AND_DENT_VEHICLE_WRAPPED'].patchValue('', {onlySelf: true, emitEvent: true, emitModelToViewChange: true, emitViewToModelChange: true});
      this._reloadJCF();
    }
    if (this.saveButtonClicked && !this.notEligible) {
      this.router.navigateByUrl('activation-banking-details');
    }
    if (this.notEligible) {
      this.quotationService.error = true;
    }
    this.vehicleWrappedModalClosed = true;
  }

  goBack () {
    this._gtmService.postGtmEvent('back_button_clicked', 'cover_details_back', 7)
    this.router.navigateByUrl('activation-vehicle-details');
  }

}
